import React from 'react';
import { useAppSelector } from './store';
import fallbackIcon from './images/icon-192x192.png';

export function WebsiteIcons() {
  const preview = useAppSelector((state) => state.website?.preview_token);
  const website = useAppSelector((state) => state.website?.website);
  const business = useAppSelector(
    (state) => state.businesses.data[state.public.businessId],
  );
  const logo = website?.settings.logo_image_id || business?.logo_image_id;
  const query = new URLSearchParams({ v: logo || 'bookem' });
  if (preview) query.set('preview_token', preview);
  const icon = (path: string) => (logo ? `${path}?${query}` : fallbackIcon);
  return (
    <>
      <link
        rel="icon"
        type="image/png"
        sizes={logo ? '32x32' : '192x192'}
        href={icon('/site-icon-32.png')}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href={icon('/site-icon-192.png')}
      />
      <link
        rel="apple-touch-icon"
        sizes={logo ? '180x180' : '192x192'}
        href={icon('/apple-touch-icon.png')}
      />
      <meta
        name="apple-mobile-web-app-title"
        content={website?.settings.name || business?.name}
      />
      {!preview && <link rel="manifest" href={`/site.webmanifest?${query}`} />}
    </>
  );
}

export const iconPaths: Record<
  string,
  { size: number; maskable?: boolean; ico?: boolean }
> = {
  '/favicon.ico': { size: 48, ico: true },
  '/site-icon-16.png': { size: 16 },
  '/site-icon-32.png': { size: 32 },
  '/apple-touch-icon.png': { size: 180 },
  '/site-icon-192.png': { size: 192 },
  '/site-icon-512.png': { size: 512 },
  '/site-icon-maskable.png': { size: 512, maskable: true },
};

export function websiteManifest(name: string, logo: string | null | undefined) {
  const version = encodeURIComponent(logo || 'bookem');
  return {
    id: '/',
    name,
    short_name: name,
    start_url: '/',
    scope: '/',
    display: 'browser',
    icons: logo
      ? [
          {
            src: `/site-icon-192.png?v=${version}`,
            sizes: '192x192',
            type: 'image/png',
            purpose: 'any',
          },
          {
            src: `/site-icon-512.png?v=${version}`,
            sizes: '512x512',
            type: 'image/png',
            purpose: 'any',
          },
          {
            src: `/site-icon-maskable.png?v=${version}`,
            sizes: '512x512',
            type: 'image/png',
            purpose: 'maskable',
          },
        ]
      : [
          {
            src: fallbackIcon,
            sizes: '192x192',
            type: 'image/png',
            purpose: 'any',
          },
        ],
  };
}
